import { get } from '@/infrastructure/http-client/axios';

export const apiValidDocument = async (documento) =>
  await get(`/cliente/datos/${documento}`);
